// This component shares its implementation with DbuVsWorkspaceWithRuntimeTable.
// All logic lives in WorkspaceWithRuntimeTableBase to eliminate code duplication.
import WorkspaceWithRuntimeTableBase from './WorkspaceWithRuntimeTableBase';
export default WorkspaceWithRuntimeTableBase;